import React, {useEffect} from 'react';
import HomeSlider from "../includes/HomeSlider";
import TournmentSlider from "../includes/TournmentSlider";
import GameTaskSlider from "../includes/GameTaskSlider";
import HFiveGameSlider from "../includes/HFiveGameSlider";
import YouTubeVideos from "../integrations/YouTubeVideos";

function HomePage() {
    useEffect(() => {
        document.title = 'Home | Jazz Esl';
    }, []);

    return (
        <>
            <HomeSlider/>
            <GameTaskSlider />
            <HFiveGameSlider />
            <TournmentSlider />
           {/* <YouTubeVideos />*/}

        </>
    );
}

export default HomePage;